import { ORDER_STATUS_TEXT, type OrderStatus } from 'utils/transportOrder';

const STATUS_LABEL_COLOR: Record<OrderStatus, string> = {
    ON_TIME: 'label-default',
    DELIVERED: 'label-success',
    DELAYED: 'label-warning',
    STOPPED: 'label-danger',
};

export type OrderStatusLabelProps = {
    status: OrderStatus | undefined;
    condensed?: boolean;
};

const OrderStatusLabel = ({ status, condensed = true }: OrderStatusLabelProps) => {
    if (status === undefined) {
        return null;
    }

    const sizeClass = condensed ? ' label-condensed' : '';

    return (
        <span className={`label ${STATUS_LABEL_COLOR[status]}${sizeClass} text-uppercase white-space-nowrap`}>
            {ORDER_STATUS_TEXT[status]}
        </span>
    );
};

export default OrderStatusLabel;
